import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
import Paginate from "vuejs-paginate";
// PALMATE
import BaseMixer from "@/router/views/BaseMixer";
let EcPaginate = /** @class */ (() => {
    let EcPaginate = class EcPaginate extends Mixins(BaseMixer) {
        onPageChange(page) {
            this.pageChanged({ currentPage: page });
        }
        onPerPageChange() {
            this.perPageChanged({ currentPerPage: this.pageSize });
        }
        get pageCount() {
            return Math.ceil(this.total / this.pageSize);
        }
        get startRecordNumber() {
            var start = (this.page - 1) * this.pageSize + 1;
            return start > this.total ? this.total : start;
        }
        get endRecordNumber() {
            var end = (this.page - 1) * this.pageSize + this.pageSize;
            return end > this.total ? this.total : end;
        }
        get recordsDisplayText() {
            return `Showing ${this.startRecordNumber} - ${this.endRecordNumber} of ${this.total} records`;
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcPaginate.prototype, "page", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcPaginate.prototype, "pageSize", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcPaginate.prototype, "total", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcPaginate.prototype, "perPageChanged", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcPaginate.prototype, "pageChanged", void 0);
    EcPaginate = __decorate([
        Component({
            name: "EcPaginate",
            components: {
                Paginate,
            },
        })
    ], EcPaginate);
    return EcPaginate;
})();
export default EcPaginate;
